export default __webpack_public_path__ + "static/media/back.11033103.svg";